var map = {
	"./map00.png": 9367,
	"./map00_cities.png": 121,
	"./map01.png": 9870,
	"./map02.png": 7701,
	"./map02_cities.png": 599,
	"./map03.png": 5436,
	"./map03_cities.png": 5964,
	"./map04.png": 2835,
	"./map05.png": 922,
	"./map06.png": 8353,
	"./map07.png": 7224,
	"./map08.png": 2031,
	"./map09.png": 6838,
	"./map09_cities.png": 8494,
	"./map09_nation.png": 9554,
	"./map10.png": 6748,
	"./map11.png": 2197,
	"./map12.png": 4846,
	"./map13.png": 3159,
	"./map14.png": 1640,
	"./map15.png": 5857,
	"./map16.png": 5690,
	"./map17.png": 6915,
	"./map18.png": 9252,
	"./map19.png": 9197,
	"./map20.png": 1281,
	"./map20_cities.png": 2675,
	"./map20_clean.png": 9203,
	"./map20_master.png": 4128
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9420;